import { IAdsState } from '../../types/interfaces/states';
import { PauseAd, PlayAd } from '@shared/types/interfaces/ads';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IAdsState = {
  lastImpression: undefined,
  impressionsUrls: [],
  pauseAd: undefined,
  playAd: undefined,
  videoAd: undefined,
};

const adsSlice = createSlice({
  name: 'ads',
  initialState,
  reducers: {
    clearImpressionUrl: (state, action: PayloadAction<string>) => {
      const currentImpressionsUrls = state.impressionsUrls;
      const index = currentImpressionsUrls.indexOf(action.payload);
      if (index !== -1) {
        currentImpressionsUrls.splice(index, 1);
      }
      state.impressionsUrls = currentImpressionsUrls;
    },
    clearPauseAd: (state) => {
      state.pauseAd = undefined;
    },
    clearPlayAd: (state) => {
      state.playAd = undefined;
    },
    clearVideoAd: (state) => {
      state.videoAd = undefined;
    },
    setImpression: (state, action: PayloadAction<number>) => {
      state.lastImpression = action.payload;
    },
    setImpressionsUrls: (state, action: PayloadAction<string[]>) => {
      state.impressionsUrls = action.payload;
    },
    setPauseAd: (state, action: PayloadAction<PauseAd>) => {
      state.pauseAd = { ...state.pauseAd, ...action.payload };
    },
    setPlayAd: (state, action: PayloadAction<PlayAd>) => {
      state.playAd = { ...state.playAd, ...action.payload };
    },
    setVideoAd: (state, action: PayloadAction<string>) => {
      // if (!state.videoAd) {
      //   state.videoAd = action.payload;
      // }
    },
  },
});

const { actions, reducer: adsReducer } = adsSlice;
export const {
  clearImpressionUrl,
  clearPauseAd,
  clearPlayAd,
  clearVideoAd,
  setImpression,
  setImpressionsUrls,
  setPauseAd,
  setPlayAd,
  setVideoAd,
} = actions;
export const adsSelector = (state: RootState) => state.ads;
export default adsReducer;
